export default __webpack_public_path__ + "static/media/Sume_HeidiValdez.a87b655c.png";